export default {
  configure: 'Configure',
  chat: 'Chat',
  transferToAgent: 'Transfer to an Agent',
  clickToHelpPerson: 'This person needs help, click to help them',
  openConversation: 'Open conversation',
  conversations: 'Conversations',
  noPendingConversations: 'There aren´t pending conversations',
  lastMessage: 'Last message',
  channel: 'Channel',
  yourConversations: 'Your conversations',
  closedConversations: 'Closed conversations',
  allConversations: 'All conversations',
  finishConversation: 'Finish conversation',
  closeChat: 'Close chat',
  loadingMessages: 'Loading messages',
  noMessagesFound: 'There isn´t any message',
  conversationAlreadyTaken: 'Conversation already taken',
  toWrite: 'Write',
  toHelp: 'Help',
  attendConversation: 'Attend conversation',
  quickResponses: 'Quick responses',
  writeMessage: 'Write message',
  conversationFinishedByAdvisor: 'Conversation finished by advisor',
  finishedConversation: 'Finished conversation',
  conversationTakenByAdvisor: 'Conversation taken by advisor',
  updatedConversation: 'Updated conversation',
  configureChat: 'Configure chat',
  loadingConversations: 'Loading conversations',
  waitingForAdvisor: 'Waiting for advisor',
  finished: 'Finished',
  takenByMe: 'Taken by me',
  takenByAdvisor: 'Taken by {advisor}',
  withAdvisor: 'With advisor',
  registered: 'The person has not written yet',
  canIHelpYouWithSomething: 'Can I help you with something?',
  attachInWebSite: 'Attach in web site',
  authenticationType: 'Authentication type',
  twoFactorAuthentication: 'Two Factor Authentication',
  noAuthentication: 'Without authentication',
  externalAuthentication: 'External authentication',
  form: 'Form',
  onDemand: 'On demand',
  onStartup: 'On startup',
  city: 'City',
  appearance: 'Appearance',
  light: 'Light',
  dark: 'Dark',
  mainColor: 'Main color',
  pickAMainColor: 'Pick a main color',
  reestablishColor: 'Reestablish color',
  backgroundColor: 'Background color',
  pickABackgroundColor: 'Pick a background color',
  customLogo: 'Custom logo',
  customTitle: 'Custom title',
  customBubbleMessage: 'Custom bubble message',
  showEmojis: 'Show emojis',
  customQuestions: 'Custom questions',
  insertChatQuestions: 'Enter the questions that you want to show in the chat',
  permanentMessages: 'Permanent messages',
  insertFirstChatMessages: 'Enter the messages that you want to appear as first chat message',
  reasonsOfFinishedConversation: 'Reasons of finished conversation',
  possibleReasonsAdvisorEndConversation: 'Enter the main reasons why an advisor may end a conversation',
  insertQuickResponsesForAdvisors: 'Enter the quick responses that advisors will have available',
  inactivityMessage: 'Inctivity message',
  enableInactivityMessage: 'Enable inactivity message',
  insertInactivityMessage: 'Enter the inactivity message',
  timeForTriggeringInactivityMessage: 'Time in seconds to trigger an inactivity message',
  attentionSchedule: 'Attention schedule',
  outOfServiceMessage: 'Out of service message',
  customFormMessage: 'Custom form message',
  nonWorkingDay: 'Nonworking day',
  allDay: 'All day',
  noOpening: 'No opening',
  noClosing: 'Without closure',
  advisors: 'Advisors',
  assignConversationsAutomaticallyToConnectedAdvisors: 'Assign conversations automatically to connected advisors',
  pickAdvisors: 'Pick advisors',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  configurationSavedSuccessfully: 'Settings saved successfully',
  insertChatInYourWebSite: 'Insert chat in yor website',
  instructionsForInsertingChat: 'In order to add the chat in your website, you must add the next script in your site\'s footer',
  copiedScript: 'Copied script',
  errorCopyingScript: 'Error copying the script',
  noMessage: 'Without message',
  toTransfer: 'Transfer',
  agentSuccessfullyTransferred: 'Agent successfully transferred',
  youAreDeclaringNoWorkingDay: 'You are declaring this day as non-working day',
  opening: 'Opening',
  closing: 'Closing',
  establishAgentsForSelfAllocationOfConversations: 'Establish agents for self-allocation of conversations',
  assignConversations: 'Assign Conversations',
  ready: 'Ready',
  advisorUpdated: 'Updated advisor',
  errorPrecessingRequest: 'An error occurred while processing the request',
  periodStatistics: 'Period statistics',
  noStatsFoundForThisDateRange: 'No statistics were found for this date range',
  forEachDayHowMuchWasTheAverageTimePerConversation: 'For each day, how much was the average time per conversation?',
  forEachAdvisorHowMuchWasTheAverageTimePerConversation: 'For each advisor, how much was the average time per conversation?',
  statsPerDay: 'Statistics per day',
  noStatsFoundForThisDay: 'No statistics found for this day',
  usersCreated: 'Users created',
  attendedConversations: 'Attended Conversations',
  noAttendedConversations: 'Unanswered Conversations',
  attendedAndUnansweredConversations: 'Attended and unattended conversations',
  attended: 'Attended',
  averageTimeBeforeTheAdvisorTookControl: 'Average time before the advisor took control',
  averageTimeSinceTheAdvisorTookControl: 'Average time since the advisor takes control',
  howManyWereAttended: 'How many were attended?',
  conversationsNumber: 'Number of conversations',
  howManyConversationsDidEachAdvisorAttended: 'How many conversations did each advisor attend?',
  numberConversationsAttended: 'Number of conversations attended',
  howManyUsersWereCreated: 'How many users were created?',
  users: 'Users',
  howLongWasTheAverageTimePerConversation: 'How long was the average time per conversation?',
  minutes: 'Minutes',
  whatWereTheTopicsOfTheConversations: 'What were the topics of the conversations',
  numberOfRepetitions: 'Number of repetitions',
  howManyConversationsWereAttendedForEachHour: 'How many conversations were attended for each hour?',
  howManyConversationsDidEachAdvisorHavePerHour: 'How many conversations did each advisor have per hour?',
  howManyUsersWereCreatedPerHour: 'How many users were created per hour?',
  advisor: 'Advisor',
  tellUsWhoYouAre: 'Tell us who you are',
  selectTheInformationYouWantToAskPeople: ' Select the information you want to ask people',
  startConversation: 'Start conversation',
  emptyMessage: 'Empty message',
  blockMessageComposer: 'Block message composer',
  timeZone: 'Time Zone',
  addSchedule: 'Add Schedule',
  checkTheServiceHours: 'Check the service hours',
  newKeybeConversation: 'New Keybe Conversation',
  details: 'Details',
  enterName: 'Enter name',
  enterEmail: 'Enter email',
  enterPhone: 'Enter phone',
  enterCountry: 'Enter country',
  country: 'Country',
  enter: 'Enter',
  enterValue: 'Enter the value',
  selectPerson: 'Select a person',
  anonymousPerson: 'This person is anonymous',
  personDetails: 'Person details',
  newApplication: 'New Application',
  channels: 'Channels',
  authentication: 'Authentication',
  finalization: 'Ending',
  customizeYourConversation: 'Customize your conversation',
  schedules: 'Schedule',
  assignment: 'Assignment',
  correctlyEmailConnection: 'Your email has been connected correctly',
  correctlyEmailDisconnection: 'Your email has been disconnected successfully',
  administratorsOnly: 'Administrators only',
  setTheEndTimeForConversations: 'Set the end time for conversations',
  automaticallyEndUnansweredConversations: 'Automatically end conversations that have stopped being answered',
  definesTheTimeUserStopsResponding: 'Defines the time to end the conversation once the user stops responding',
  finishAfter: 'Finish after',
  enterTheReasonForAutomaticCompletion: 'Enter the reason for automatic completion',
  position: 'Position',
  defaultLanguage: 'Default language',
  tagsAsAMethodOfAutoAssignment: 'Tags as a method of auto-assignment',
  enterTags: 'Enter Tags',
  updateTags: 'Update Tags',
  communicationChannels: 'Communication channels',
  youMustPreviouslyGrantKeybeGooglePermission: 'You must previously grant Keybe permissions to access your Google account',
  connectWithGoogle: 'Connect with Google',
  youHaveCurrentlyAuthorizedKeybe: 'You have currently authorized Keybe to access your account',
  andYouHaveCorrectlyConfiguredGmail: 'and you have correctly configured Gmail',
  disconnectFromGmail: 'Disconnect from gmail',
  connectToGmail: 'Connect to gmail',
  confirmationTimeout: 'Confirmation timeout',
  serverUrl: 'Server url',
  pickATimeGreaterOrEqualThan15Minutes: 'Pick a time greater or equal than 15 minutes',
  conversationWithAdviser: 'Conversation with adviser',
  conversationWithAI: 'Conversation with AI'
}
